import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './CardModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHome, 
  faTasks, 
  faFolder, 
  faStar, 
  faClock, 
  faComment, 
  faGamepad, 
  faChartBar, 
  faUserShield, 
  faDragon, 
  faUsers, 
  faDice, 
  faSkull 
} from '@fortawesome/free-solid-svg-icons';
import { 
  faCalendar
} from '@fortawesome/free-regular-svg-icons';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { useUser } from '../UserContext';
import { Link } from "react-router-dom";

const Categories = ({ setCurrentPage, onCategoryClick }) => {
  const [showBestOf, setShowBestOf] = useState(false);
  const [showSpecialCategories, setShowSpecialCategories] = useState(false);
  const { user, setUser, filters, setFilters } = useUser();

  const handleCategoryClick = (category) => {
    //setCurrentPage(0);
    if (category === filters.category) { setCurrentPage(0); }
    onCategoryClick();
  };
  
  const toggleBestOf = () => {
    setShowBestOf(!showBestOf);
  };
  
  const toggleSpecialCategories = () => {
    setShowSpecialCategories(!showSpecialCategories);
  };

  const getButtonClass = (category) => {
    return filters.category === category ? 'btn btn-primary active' : 'btn btn-primary';
  };

  return (
    <div className="w-100" role="group">
      {user && (
        <>
      <Link to="/gallery/mycards/" style={{ textDecoration: 'none' }} onClick={() => handleCategoryClick('300')}>
        <img src="/images/button-mycards.webp" className="category-button" style={{width: '100%'}}/>
      </Link>
      <Link to="/gallery/?category=100" style={{ textDecoration: 'none' }} onClick={() => handleCategoryClick('100')}>
        <img src="/images/button-favorites.webp" className="category-button mb-3" style={{width: '100%'}}/>
      </Link>
      </>
      )
      }
      <Link to="/gallery/?category=9"  style={{ textDecoration: 'none' }} onClick={() => handleCategoryClick('9')}>
        <img src="/images/button-queue.webp" className="category-button" style={{width: '100%'}}/>
      </Link>
      <Link to="/gallery/sets" style={{ textDecoration: 'none' }} onClick={() => handleCategoryClick('600')}>
        <img src="/images/button-sets.webp" className="category-button" style={{width: '100%'}}/>
      </Link>
      <Link to="/gallery/contests/list" style={{ textDecoration: 'none' }} onClick={() => onCategoryClick()}>
        <img src="/images/button-contests.webp" className="category-button" style={{width: '100%'}}/>
      </Link>

      <div className="position-relative" onClick={toggleBestOf} style={{cursor: 'pointer'}}>
        <img src="/images/button-best-cards.webp" className="category-button" style={{width: '100%'}}/>
        <div className="position-absolute" style={{top: '50%', right: '7%', transform: 'translateY(-65%)'}}>
          {showBestOf ? <FaChevronUp size={18} color="white" style={{ stroke: 'black', strokeWidth: '40' }} /> : <FaChevronDown size={18} color="white" style={{ stroke: 'black', strokeWidth: '40' }} />}
        </div>
      </div>

      {showBestOf && (
        <div className="btn-group-vertical w-100" role="group">
          <Link to="/gallery/?category=1" className={`filter align-self-center ${getButtonClass('1')}`} style={{ textDecoration: 'none', width: '90%' }} onClick={() => handleCategoryClick('1')}>
            <FontAwesomeIcon icon={faCalendar} /> All Time
          </Link>
          <Link to="/gallery/?category=10" className={`filter align-self-center ${getButtonClass('10')}`} style={{ textDecoration: 'none', width: '90%' }} onClick={() => handleCategoryClick('10')}>
            <FontAwesomeIcon icon={faCalendar} /> Year
          </Link>
          <Link to="/gallery/?category=2" className={`filter align-self-center ${getButtonClass('2')}`} style={{ textDecoration: 'none', width: '90%' }} onClick={() => handleCategoryClick('2')}>
            <FontAwesomeIcon icon={faCalendar} /> Month
          </Link>
          <Link to="/gallery/?category=3" className={`filter align-self-center ${getButtonClass('3')}`} style={{ textDecoration: 'none', width: '90%' }} onClick={() => handleCategoryClick('3')}>
            <FontAwesomeIcon icon={faCalendar} /> Week
          </Link>
          <Link to="/gallery/?category=4" className={`filter align-self-center ${getButtonClass('4')}`} style={{ textDecoration: 'none', width: '90%' }} onClick={() => handleCategoryClick('4')}>
            <FontAwesomeIcon icon={faCalendar} /> Day
          </Link>
        </div>
      )}

      <div className="position-relative" onClick={toggleSpecialCategories} style={{cursor: 'pointer'}}>
        <img src="/images/button-game-modes.webp" className="category-button" style={{width: '100%'}}/>
        <div className="position-absolute" style={{top: '50%', right: '7%', transform: 'translateY(-65%)'}}>
          {showSpecialCategories ? <FaChevronUp size={18} color="white" style={{ stroke: 'black', strokeWidth: '40' }} /> : <FaChevronDown size={18} color="white" style={{ stroke: 'black', strokeWidth: '40' }} />}
        </div>
      </div>

      {showSpecialCategories && (
        <div className="btn-group-vertical w-100 mt-1" role="group">
          <Link to="/gallery/?category=202" className={getButtonClass('202')} style={{ textDecoration: 'none' }} onClick={() => handleCategoryClick('202')}>
            <FontAwesomeIcon icon={faChartBar} /> Keywords
          </Link>
          <Link to="/gallery/?category=207" className={getButtonClass('207')} style={{ textDecoration: 'none' }} onClick={() => handleCategoryClick('207')}>
            <FontAwesomeIcon icon={faUserShield} /> Mercenaries
          </Link>
          <Link to="/gallery/?category=203" className={getButtonClass('203')} style={{ textDecoration: 'none' }} onClick={() => handleCategoryClick('203')}>
            <FontAwesomeIcon icon={faDragon} /> Boss Cards
          </Link>
          <Link to="/gallery/?category=204" className={getButtonClass('204')} style={{ textDecoration: 'none' }} onClick={() => handleCategoryClick('204')}>
            <FontAwesomeIcon icon={faUsers} /> Brawls
          </Link>
          <Link to="/gallery/?category=206" className={getButtonClass('206')} style={{ textDecoration: 'none' }} onClick={() => handleCategoryClick('206')}>
            <FontAwesomeIcon icon={faDice} /> Battlegrounds
          </Link>
          <Link to="/artsaron" className={getButtonClass('206')} style={{ textDecoration: 'none' }}>
            <FontAwesomeIcon icon={faDice} /> Art-Saron
          </Link>
        </div>
      )}
      {user && (
        <>
      <Link to="/gallery/?category=400" style={{ textDecoration: 'none' }} onClick={() => handleCategoryClick('400')}>
        <img src="/images/button-void.webp" className="category-button" style={{width: '100%'}}/>
      </Link>
      </>
      )}
      <Link to="/gallery/?category=101" style={{ textDecoration: 'none' }} onClick={() => handleCategoryClick('101')}>
        <img src="/images/button-recent-comments.webp" className="category-button" style={{width: '100%'}}/>
      </Link>
    </div>
  );
}

export default Categories;